import React from 'react';
import { COST_CHART_TYPE } from 'pluton-core/lib/constants/data.constant';


class CostTypeSelector extends React.Component {

    render() {
        return (
            <div className="select">
                <span className="select__name">Type</span>
                <div className="select__item">
                    <select value={this.props.value} className="select__field" onChange={this.props.onChange}>
                        <option value={COST_CHART_TYPE.DAY}>Day</option>
                        <option value={COST_CHART_TYPE.WEEK}>Week</option>
                        <option value={COST_CHART_TYPE.MONTH}>Month</option>
                    </select>
                </div>
            </div>
        );
    }
}

CostTypeSelector.propTypes = {
    onChange: React.PropTypes.func
};

export default CostTypeSelector;



// WEBPACK FOOTER //
// ./app/components/controls/costTypeSelector/CostTypeSelector.jsx